import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {

  @Input() isLoading!: boolean;
  @Input() isFixedPosition = true;
  @Input() isWithSearchPanel!: boolean;

  constructor() {
    this.isLoading = false;
  }

  ngOnInit(): void {
  }

}
